// Importing the Flag component for displaying a flag
import Flag from "../components/Flag";
// Importing specific text-related components (H2) and a generic Button component
import { H2, H2SMALL } from "../components/Text";
import Button from "../components/Button";
import React, { useState, useEffect } from "react";
import Interpretation from "../components/Interpretation";
import "./Results.css";
import Logo from "../images/Pronouns compass/Svgs/Logo";
import FlagFirstThree from "../components/FlagFirstThree";
import FlagLastThree from "../components/FlagLastThree";
import Menu from "../components/Menu";
import { writeFlagData } from "../components/Database";
import { url } from "../config.js";
import ShareButtons from "../components/ShareButtons.jsx";
import { Share } from "@capacitor/share";
import Interactive from "../images/Pronouns compass/Svgs/Interactive.jsx";
import InteractiveDesktop from "../images/Pronouns compass/Svgs/InteractiveDesktop.jsx";
import ThisToo from "../images/Pronouns compass/Svgs/ThisToo.jsx";
import ThisTooDesktop from "../images/Pronouns compass/Svgs/ThisTooDesktop.jsx";

// Importing the save-svg-as-png library for saving SVG as PNG
const saveSvgAsPng = require("save-svg-as-png");

// Results component responsible for displaying the results page
const Results = ({ data, previous }) => {
  //stores uuid as a result from sharing flag
  const [uuid, setUuid] = useState("");

  useEffect(() => {
    if (previous != null) {
      shareFlag();
    }
  }, []);

  // Function to handle the download action
  const download_800 = () => {
    // Retrieve the SVG element with the ID "flag"
    const svg = document.getElementById("flag");
    // console.log(svg);
    // Remove ng-reflect-tooltip-title attribute from elements with ngx-tooltip attribute
    // let elArray = svg.querySelectorAll("[ngx-tooltip]");
    // elArray.forEach(function (element) {
    //   element.removeAttribute("ng-reflect-tooltip-title");
    // });
    // Save the modified SVG as a PNG file using save-svg-as-png library
    saveSvgAsPng.saveSvgAsPng(svg, "myflag.png", {
      // canvg: window.canvg, // Using the canvg library for rendering SVG to canvas
      // TODO Change scaling factor for different resolutions of image for download.
      scale: 9, // Scaling factor for the output PNG.
      backgroundColor: "white",
    });
  };

  // Function to handle the download action
  const download_1600 = () => {
    // Retrieve the SVG element with the ID "flag"
    const svg = document.getElementById("flag");
    // Remove ng-reflect-tooltip-title attribute from elements with ngx-tooltip attribute
    let elArray = svg.querySelectorAll("[ngx-tooltip]");
    elArray.forEach(function (element) {
      element.removeAttribute("ng-reflect-tooltip-title");
    });
    // Save the modified SVG as a PNG file using save-svg-as-png library
    saveSvgAsPng.saveSvgAsPng(svg, "myflag.png", {
      // canvg: window.canvg, // Using the canvg library for rendering SVG to canvas
      // TODO Change scaling factor for different resolutions of image for download.
      canvg: window.canvg,
      scale: 18, // Scaling factor for the output PNG.
      backgroundColor: "white",
    });
  };

  // Log the data to the console (for debugging or informational purposes)
  // console.log("data is:", data);

  const getPronouns = (colorObject) => {
    if (colorObject === undefined) {
      return ["na"]; // Adjust the value to your preference
    }
    const trueColors = Object.keys(colorObject.colors).filter(
      (color) => colorObject.colors[color]
    );
    return trueColors;
  };

  const getColors = (colorObject) => {
    if (colorObject === undefined) {
      return ["white"]; // Adjust the value to your preference
    }

    if (colorObject.ratherNot) {
      // console.log("ratherNot");
      return ["white"];
    } else if (colorObject.colors["rainbow"]) {
      return ["purple", "red", "orange", "yellow", "green", "blue", "purple"];
    }
    const customOrder = ["red", "orange", "yellow", "green", "blue", "purple"];
    // get all the keys who's values are true
    const colorsArray = Object.keys(colorObject.colors)
      .filter((color) => colorObject.colors[color] === true)
      .sort((a, b) => {
        return customOrder.indexOf(a) - customOrder.indexOf(b);
      });
    // if the last value is purple, we need to stick purple at the front as well
    if (colorsArray[colorsArray.length - 1] === "purple")
      colorsArray.unshift("purple");
    return colorsArray;
  };

  const getPoly = (colorObject) => {
    if (colorObject === undefined) {
      return ["grey_2"]; //default; not poly
    }
    if (colorObject.colors["grey"]) {
      return ["grey"];
    } else {
      return ["grey_2"];
    }
  };

  function restart() {
    // Change the location to the root directory ("/")
    window.location.href = "/";
  }

  async function shareFlag() {
    try {
      const uuidResult = await writeFlagData(data);
      setUuid(uuidResult);
    } catch (error) {
      console.log(error);
    }
  }

  function getInterpretationElements() {
    var self = document.getElementById("self");
    var body = document.getElementById("body");
    var pronouns = document.getElementById("pronouns");
    // var emotionalAndPhysical = document.getElementById("emotionalAndPhysical");
    var poly = document.getElementById("polyamorous");
    var emotional = document.getElementById("emotional");
    var emotional2 = document.getElementById("emotional2");
    var experience = document.getElementById("experience");
    var experience2 = document.getElementById("experience2");
    var experience3 = document.getElementById("experience3");
    var experience4 = document.getElementById("experience4");
    var physical = document.getElementById("physical");
    var physical2 = document.getElementById("physical2");
    return [
      self,
      body,
      pronouns,
      // emotionalAndPhysical,
      poly,
      emotional,
      emotional2,
      experience,
      experience2,
      experience3,
      experience4,
      physical,
      physical2,
    ];
  }

  function resetHover() {
    var interpretations = getInterpretationElements();
    for (let i = 0; i < interpretations.length; ++i) {
      if (interpretations[i]) {
        interpretations[i].classList.remove("opacity-hovered");
      }
    }
  }

  function hoverPronouns() {
    var interpretations = getInterpretationElements();
    var pronouns = document.getElementById("pronouns");
    for (let i = 0; i < interpretations.length; ++i) {
      if (interpretations[i] && interpretations[i] !== pronouns) {
        interpretations[i].classList.toggle("opacity-hovered");
      }
    }
  }

  function hoverPoly() {
    var interpretations = getInterpretationElements();
    var polyamorous = document.getElementById("polyamorous");
    for (let i = 0; i < interpretations.length; ++i) {
      if (interpretations[i] && interpretations[i] !== polyamorous) {
        interpretations[i].classList.toggle("opacity-hovered");
      }
    }
  }
  function hoverTriangle() {
    var interpretations = getInterpretationElements();
    var self = document.getElementById("self");
    for (let i = 0; i < interpretations.length; ++i) {
      if (interpretations[i] && interpretations[i] !== self) {
        interpretations[i].classList.toggle("opacity-hovered");
      }
    }
  }
  function hoverChevron() {
    var interpretations = getInterpretationElements();
    var body = document.getElementById("body");
    for (let i = 0; i < interpretations.length; ++i) {
      if (interpretations[i] && interpretations[i] !== body) {
        interpretations[i].classList.toggle("opacity-hovered");
      }
    }
  }
  function hoverEmotional() {
    try {
      var interpretations = getInterpretationElements();
      var emotional = document.getElementById("emotional");
      var emotional2 = document.getElementById("emotional2");
      var experience = document.getElementById("experience");
      var experience2 = document.getElementById("experience2");
      var experience3 = document.getElementById("experience3");

      for (let i = 0; i < interpretations.length; ++i) {
        if (
          interpretations[i] &&
          interpretations[i] !== emotional2 &&
          interpretations[i] !== emotional &&
          interpretations[i] !== experience &&
          interpretations[i] !== experience2 &&
          interpretations[i] !== experience3
        ) {
          interpretations[i].classList.toggle("opacity-hovered");
        }
      }
    } catch (e) {}
  }
  function hoverPhysical() {
    try {
      var interpretations = getInterpretationElements();
      var physical = document.getElementById("physical");
      var physical2 = document.getElementById("physical2");
      var experience = document.getElementById("experience");
      var experience2 = document.getElementById("experience2");
      var experience3 = document.getElementById("experience3");

      for (let i = 0; i < interpretations.length; ++i) {
        if (
          interpretations[i] &&
          interpretations[i] !== physical &&
          interpretations[i] !== physical2 &&
          interpretations[i] !== experience &&
          interpretations[i] !== experience2 &&
          interpretations[i] !== experience3
        ) {
          interpretations[i].classList.toggle("opacity-hovered");
        }
      }
    } catch (e) {}
  }
  function hoverBoth() {
    try {
      var interpretations = getInterpretationElements();
      var emotional = document.getElementById("emotional");
      var emotional2 = document.getElementById("emotional2");
      var physical = document.getElementById("physical");
      var physical2 = document.getElementById("physical2");
      var experience = document.getElementById("experience");
      var experience2 = document.getElementById("experience2");
      var experience3 = document.getElementById("experience3");
      var experience4 = document.getElementById("experience4");

      for (let i = 0; i < interpretations.length; ++i) {
        if (
          interpretations[i] &&
          interpretations[i] !== emotional &&
          interpretations[i] !== emotional2 &&
          interpretations[i] !== physical &&
          interpretations[i] !== physical2 &&
          interpretations[i] !== experience &&
          interpretations[i] !== experience2 &&
          interpretations[i] !== experience3 &&
          interpretations[i] !== experience4
        ) {
          interpretations[i].classList.toggle("opacity-hovered");
        }
      }
    } catch (e) {}
  }

  const areFirstThreeTrue =
    data[0].ratherNot === true &&
    data[1].ratherNot === true &&
    data[2].ratherNot === true;
  const areLastThreeTrue =
    data[3].ratherNot === true &&
    data[4].ratherNot === true &&
    data[5].ratherNot === true;

  function showDesktopIcons() {
    const mobile = document.getElementById("share-mobile");
    const desktop = document.getElementById("share-desktop");
    mobile.classList.add("hidden");
    mobile.classList.remove("share-mobile");
    desktop.classList.add("visible");
    desktop.classList.remove("share-desktop");
  }

  // Render the results page with a flag, a heading, and a download button
  return (
    <div
      style={{ textAlign: "center", paddingLeft: "10px", paddingRight: "10px" }}
    >
      {/* logo */}
      <div
        id="logo-results"
        onClick={() => {
          restart();
        }}
        style={{ paddingTop: "10px", cursor: "pointer" }}
      >
        <Logo width={"100%"} height={"50%"} id={"logo"} />
      </div>
      {/* Display a heading for the results page */}
      <H2 style={{ userSelect: "none" }}>Here is your flag...</H2>
      {/* Render the Flag component to display the flag */}
      <div
        className="interactive-mobile-container"
        style={{ bottom: "90px", left: `${window.screen.width - 225}px` }}
      >
        <Interactive height={200} width={200} id={"interactive-mobile"} />
      </div>
      <div className="interactive-desktop-container">
        <InteractiveDesktop
          height={200}
          width={200}
          id={"interactive-desktop"}
        />
      </div>

      {!areFirstThreeTrue && !areLastThreeTrue && (
        <Flag
          triangle={getColors(data[0])}
          chevron={getColors(data[1])}
          hStripeColors={getColors(data[4])}
          vStripeColors={getColors(data[3])}
          pronouns={getPronouns(data[2])}
          poly={getPoly(data[5])}
          hoverPronouns={hoverPronouns}
          hoverPoly={hoverPoly}
          hoverTriangle={hoverTriangle}
          hoverChevron={hoverChevron}
          hoverEmotional={hoverEmotional}
          hoverPhysical={hoverPhysical}
          hoverBoth={hoverBoth}
          resetHover={resetHover}
        />
      )}

      {areLastThreeTrue && (
        <FlagFirstThree
          self={getColors(data[0])}
          body={getColors(data[1])}
          pronoun={getPronouns(data[2])}
          hoverPronouns={hoverPronouns}
          hoverTriangle={hoverTriangle}
          hoverChevron={hoverChevron}
          resetHover={resetHover}
        />
      )}

      {areFirstThreeTrue && (
        <FlagLastThree
          hStripeColors={getColors(data[4])}
          vStripeColors={getColors(data[3])}
          poly={getPoly(data[5])}
          hoverPoly={hoverPoly}
          hoverEmotional={hoverEmotional}
          hoverPhysical={hoverPhysical}
          hoverBoth={hoverBoth}
          resetHover={resetHover}
        />
      )}
      <div className="this-too-mobile-container">
        <ThisToo height={100} width={100} id={"this-too-mobile"} />
      </div>
      <div className="this-too-desktop-container">
        <ThisTooDesktop height={200} width={200} id={"this-too-desktop"} />
      </div>

      <H2SMALL
        style={{ marginBottom: "0px", marginTop: "10px", userSelect: "none" }}
      >
        It says...
      </H2SMALL>
      <Interpretation data={data} />
      <div
        className="button-container-1"
        style={{
          display: "flex",
          justifyContent: "space-evenly",
          marginTop: "20px",
          marginBottom: "25px",
          paddingBottom: "25px",
        }}
      >
        {/* Render a Button component for triggering the download action */}
        {previous !== null && (
          <div
            className="back-button-mobile"
            onClick={() => {
              previous();
            }}
          >
            <Button type={"back"} enabled={true.toString()}></Button>
          </div>
        )}
        <div
          className="restart-button-mobile"
          onClick={() => {
            restart();
          }}
        >
          <Button type={"restart"} enabled={true.toString()}></Button>
        </div>
        <div onClick={download_800}>
          <Button type={"download_800"} enabled={true.toString()}></Button>
        </div>

        <div onClick={download_1600}>
          <Button type={"download_1600"} enabled={true.toString()}></Button>
        </div>
      </div>

      <div
        className="button-container-2"
        style={{
          display: "flex",
          justifyContent: "space-evenly",
          marginTop: "20px",
          marginBottom: "25px",
          paddingBottom: "25px",
        }}
      >
        {/* button to go back to the previous question*/}
        {previous !== null && (
          <div
            onClick={() => {
              previous();
            }}
          >
            <Button type={"back"} enabled={true.toString()}></Button>
          </div>
        )}

        {/* button to restart to the first question*/}
        <div
          onClick={() => {
            restart();
          }}
        >
          <Button type={"restart"} enabled={true.toString()}></Button>
        </div>
      </div>
      {uuid && previous != null && (
        <div className="share-desktop" id="share-desktop">
          <p>Share your flag!</p>
          <ShareButtons url={url + "flag/" + uuid} />
        </div>
      )}
      {uuid && previous != null && (
        <div
          className="share-mobile"
          id="share-mobile"
          onClick={async () => {
            try {
              await Share.share({
                title: "Pride Flag Project",
                text: "Check out my Pride Flag that I created!",
                url: url + "flag/" + uuid,
                dialogTitle: "Share",
              });
            } catch (error) {
              showDesktopIcons();
            }
          }}
        >
          <Button type={"share"}></Button>
        </div>
      )}

      <Menu />
    </div>
  );
};

// Exporting the Results component as the default export
export default Results;
